var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12390_6556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#6C5CE7",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.063 11.2496C28.665 9.58346 31.2625 9.58346 32.8646 11.2496L34.7984 13.2608C36.4005 14.927 36.4005 17.6284 34.7984 19.2945L20.5872 34.0743C20.3963 34.2728 20.1531 34.4081 19.8884 34.4632L12.6364 35.9716C11.6796 36.1706 10.8359 35.2933 11.0273 34.2982L12.4777 26.7561C12.5307 26.4807 12.6608 26.2279 12.8517 26.0293L27.063 11.2496ZM31.8976 12.2552L33.8315 14.2665C34.8996 15.3772 34.8996 17.1781 33.8315 18.2889L31.4141 20.8029L25.6125 14.7693L28.0299 12.2552C29.0979 11.1445 30.8296 11.1445 31.8976 12.2552ZM24.6456 15.7749L13.8186 27.035L12.3682 34.5771L19.6202 33.0686L30.4472 21.8086L24.6456 15.7749Z",
    fill: "#2D3436"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12390_6556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroup);
export default __webpack_public_path__ + "static/media/edit-group.3de033ff683e834bf37c65609b6d0a76.svg";
export { ForwardRef as ReactComponent };